var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstitute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2538",
    "data-name": "Rectangle 2538",
    width: 14.572,
    height: 14.017,
    fill: "#292961"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13689",
    "data-name": "Group 13689",
    transform: "translate(-0.18 0.311)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2540",
    "data-name": "Rectangle 2540",
    width: 18,
    height: 18,
    transform: "translate(0.18 -0.311)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6680",
    "data-name": "Group 6680",
    transform: "translate(1.836 1.345)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2539",
    "data-name": "Rectangle 2539",
    width: 14,
    height: 14,
    transform: "translate(0.344 0.344)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6679",
    "data-name": "Group 6679",
    transform: "translate(0.058 0.486)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6678",
    "data-name": "Group 6678",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25744",
    "data-name": "Path 25744",
    d: "M244.778,98.435a1.875,1.875,0,0,1-.373.8,1.546,1.546,0,0,1-2.322.03.172.172,0,0,0-.218-.054c-.317.108-.637.209-.949.311l-.32-.981.534-.174a3.812,3.812,0,0,1,.392-.125c.125-.026.16-.094.175-.212a1.543,1.543,0,0,1,2.928-.464,3.968,3.968,0,0,1,.153.47Z",
    transform: "translate(-230.207 -92.506)",
    fill: "#292961"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25745",
    "data-name": "Path 25745",
    d: "M115.2,119.838a2.412,2.412,0,1,1-2.417,2.4,2.418,2.418,0,0,1,2.417-2.4",
    transform: "translate(-107.908 -114.663)",
    fill: "#292961"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25746",
    "data-name": "Path 25746",
    d: "M54.168,233.54c-.191.264-.388.541-.593.813a.165.165,0,0,0-.016.213,1.545,1.545,0,0,1-1.913,2.21,1.546,1.546,0,0,1,.872-2.954.19.19,0,0,0,.234-.088c.188-.273.387-.538.581-.8l.834.609",
    transform: "translate(-48.484 -222.873)",
    fill: "#292961"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25747",
    "data-name": "Path 25747",
    d: "M205.735,233.64l.83-.6c.017.02.045.051.069.084.154.21.315.416.457.634a.307.307,0,0,0,.363.162,1.526,1.526,0,0,1,1.7,1.044,1.548,1.548,0,1,1-2.817-.28.182.182,0,0,0-.016-.238c-.2-.268-.4-.541-.585-.8",
    transform: "translate(-196.851 -222.973)",
    fill: "#292961"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25748",
    "data-name": "Path 25748",
    d: "M4.178,98.415l-.319.981c-.3-.1-.62-.194-.932-.3a.2.2,0,0,0-.252.063,1.479,1.479,0,0,1-1.6.419,1.458,1.458,0,0,1-1.051-1.2,1.542,1.542,0,0,1,3.027-.589.41.41,0,0,0,.357.378c.264.069.52.165.767.246",
    transform: "translate(0 -92.38)",
    fill: "#292961"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25749",
    "data-name": "Path 25749",
    d: "M134.8,4.153h-1.03c0-.253-.012-.518,0-.781a.44.44,0,0,0-.263-.493,1.493,1.493,0,0,1-.748-1.614,1.547,1.547,0,0,1,3.068.327,1.5,1.5,0,0,1-.932,1.378.149.149,0,0,0-.1.162c0,.34,0,.681,0,1.021",
    transform: "translate(-127 0)",
    fill: "#292961"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstitute);
export default __webpack_public_path__ + "static/media/institute.ebdc02b76c32f59a55aba34127501566.svg";
export { ForwardRef as ReactComponent };